<template>
  <div class="footer-inner footer-nav">
    <GenerationLinks />
    <CategoryLinks />
    <PopularCategoryLinks />
    <PageLinks :user="user" />
  </div>
</template>

<script>
import GenerationLinks from '../GenerationLinks/GenerationLinks';
import PageLinks from '../PageLinks/PageLinks';
import CategoryLinks from '../CategoryLinks/CategoryLinks';
import PopularCategoryLinks from '../PopularCategoryLinks/PopularCategoryLinks';

export default {
  name: 'FooterNav',
  props: {
    user: {
      type: Object
    }
  },
  components: {
    GenerationLinks,
    PageLinks,
    CategoryLinks,
    PopularCategoryLinks
  }
};
</script>
